









































































































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import { DraftPrivatePayRequest, GPSLocation, Language, LiveRideDetails, ServiceRequest } from '@/types/entity';
import GoogleMap from '../../components/GoogleMap.vue';
import { DateUtils } from '@/util/dateUtils';
import FareDetails from '@/components/FareDetails.vue';
import { ResourceUtils } from '@/util/resourceUtils';

interface Step {
    key: string;
    label: string;
    icon: string;
}

@Component({
    components: {
        GoogleMap,
        FareDetails,
    },
    mixins: [validationMixin],
    data() {
        return {
            hasStarted: false,
            showBookingStatus: false,
            showMap: false,
            driverLocation: {
                latitude: 0,
                longitude: 0,
            },
            pickupAddressCoordinates: {
                lat: 0,
                lng: 0,
            },
            dropoffAddressCoordinates: {
                lat: 0,
                lng: 0,
            },
            requestId: '',
            appointmentTime: '',
            ETAForDriverArrival: '',
            driverName: '',
            vehicleDetails: {
                makeModal: '',
                year: '',
                color: '',
                licensePlate: '',
            },
            vehicleType: '',
            pickupAddress: '',
            dropoffAddress: '',
            isLinkValid: true,
            patientPickedUp: false,
            mapRefreshCount: 0,
        };
    },
})

export default class PrivatePayRequestProgressModal extends Vue {
    private steps: Step[] = [
        { key: 'REQUEST_RECIEVED', label: 'Request Received', icon: 'fa-solid fa-receipt' },
        { key: 'PAYENT_COMPLETED', label: 'Payment Verified', icon: 'fas fa-credit-card' },
        { key: 'ASSIGNING_DRIVER', label: 'Assigning Driver', icon: 'fas fa-credit-card' },
        { key: 'SERVICE_CONFIRMED', label: 'Service Confirmed', icon: 'fas fa-car' },
        { key: 'SERVICE_IN_PROGRESS', label: 'Service in Progress', icon: 'fas fa-paper-plane' },
        { key: 'SERVICE_COMPLETED', label: 'Service Completed', icon: 'fas fa-flag-checkered' },
    ];
    private errorMessage = '';
    private isLinkValid = true;
    private patientName: string = '';
    private appointmentDateTime: string = '';
    private serviceType: string = '';
    private serviceRequest: DraftPrivatePayRequest | null = null;
    private fareDetails: any = null;
    private showFareDetails: boolean = false;
    private currentStepKey: string = '';
    private driverLocation: GPSLocation | undefined = undefined;
    private intervalId: number | null = null;
    private pdResourceId: string = '';
    private invoiceId: string = '';
    private intervalId2: number | null = null;
    private requestId = '';
    private isTransportRequest = false;
    private vehicleType = '';
    private appointmentDate: string = '';
    private pickUpTime: string = '';
    private returnPickupTime: string = '';
    private lastCompletedStepKey = 'PAYENT_COMPLETED';
    private status = '';

    private async mounted() {
        await this.getPrivatePayRequestProgressDetails();

        this.intervalId2 = window.setInterval(() => {
            this.getPrivatePayRequestProgressDetails();
        }, 5000);
    }

    private beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        if (this.intervalId2) {
            clearInterval(this.intervalId2);
        }
    }

    private async getPrivatePayRequestProgressDetails() {
        const iHttpService = ObjectFactory.getHttpService();
        try {
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/${this.$route.params.id}`,
            };
            if (!this.intervalId2) {
                apiRequest.loaderEvent = {
                    show: true,
                };
            }
            const response = await iHttpService.get<DraftPrivatePayRequest>(apiRequest);
            if (response.success && response.data) {
                this.serviceRequest = response.data;
                this.patientName = response.data.appointment.patient.fullName as any;
                this.appointmentDateTime = DateUtils.formatDate(response.data.appointment.timestamp,
                    DateUtils.FORMAT_DATETIME_AM_PM, response.data.appointment.timezone);
                this.appointmentDate = DateUtils.formatDate(response.data.appointment.timestamp,
                    DateUtils.FORMATE_DATE, response.data.appointment.timezone);
                this.pickUpTime = DateUtils.formatDate(response.data.appointment.timestamp,
                    'hh:mm A z', response.data.appointment.timezone);
                this.serviceType = response.data.transportRequest ? 'Transportation' : 'Interpretation';
                this.requestId = response.data.requestId ? response.data.requestId : '';
                const status = response.data.status || '';
                this.status = status;
                if (response.data.transportRequest) {
                    this.isTransportRequest = true;
                    const transportRequest = response.data.transportRequest;
                    this.vehicleType = transportRequest.vehicleType;
                    if (transportRequest.routes.length && transportRequest.routes.length > 1) {
                        this.returnPickupTime = DateUtils.formatDate(transportRequest.routes[1].pickupTime,
                        'hh:mm A z', response.data.appointment.timezone);
                    }
                }
                if (response.data.interpretationRequest && !this.isTransportRequest) {
                    this.steps = this.steps.filter((step) => step.key !== 'ASSIGNING_DRIVER');
                }
                if (status === 'SERVICE_CANCELLED') {
                    if (response.data.transportRequest.routes.length &&
                        response.data.transportRequest.routes[0].status === 'Accepted') {
                        this.lastCompletedStepKey = 'SERVICE_CONFIRMED';
                    }
                    const lastCompletedIndex = this.steps.findIndex((step) => step.key === this.lastCompletedStepKey);
                    let updatedSteps: Step[] = [];

                    if (this.lastCompletedStepKey === 'PAYENT_COMPLETED' && this.isTransportRequest) {
                        updatedSteps = this.steps.slice(0, lastCompletedIndex + 1);
                        const assigningDriverStep = this.steps.find((step) => step.key === 'ASSIGNING_DRIVER');
                        if (assigningDriverStep && !updatedSteps.find((step) => step.key === 'ASSIGNING_DRIVER')) {
                            updatedSteps.push(assigningDriverStep);
                        }
                    } else {
                        updatedSteps = this.steps.slice(0, lastCompletedIndex + 1);
                    }
                    updatedSteps.push({ key: 'SERVICE_CANCELLED', label: 'Service Cancelled', icon: 'fas fa-flag-checkered' });

                    this.steps = updatedSteps;
                    this.currentStepKey = 'SERVICE_CANCELLED';
                } else {
                    const currentIndex = this.steps.findIndex((step) => step.key === status);
                    if (currentIndex >= 0) {
                        this.lastCompletedStepKey = this.steps[currentIndex].key;
                    }
                    if (currentIndex !== -1) {
                        if (status === 'SERVICE_COMPLETED' || status === 'SERVICE_IN_PROGRESS' || status === 'ASSIGNING_DRIVER'
                            || status === 'PAYENT_COMPLETED') {
                            this.currentStepKey = this.steps[currentIndex].key;
                        } else {
                            this.currentStepKey = this.steps[currentIndex + 1].key || '';
                        }
                    } else {
                        this.currentStepKey = '';
                    }
                }
                this.invoiceId = response.data.id || '';
                if (response.data.invoice) {
                    this.pdResourceId = response.data.invoice.pdfResourceId || '';
                }

                const route = response.data.transportRequest.routes.find((r) => r.status === 'In-Progress');
                if (route && this.currentStepKey === 'SERVICE_IN_PROGRESS') {
                    this.$data.pickupAddress = route.pickupAddress.fullAddress;
                    this.$data.dropoffAddress = route.dropoffAddress.fullAddress;
                    this.$data.driverName = route.driverName;
                    this.$data.vehicleType = response.data.transportRequest.vehicleType;
                    this.$data.ETAForDriverArrival = DateUtils.formatDate(route.expectedArrivalTime);
                    this.$data.pickupAddressCoordinates = {
                        lat: route.pickupAddress.latitude,
                        lng: route.pickupAddress.longitude,
                    };
                    this.$data.dropoffAddressCoordinates = {
                        lat: route.dropoffAddress.latitude,
                        lng: route.dropoffAddress.longitude,
                    };
                    const driverLocation = route.tripDetails;
                    if (driverLocation && driverLocation.driverLocation) {
                        this.$data.driverLocation = {
                            latitude: driverLocation.driverLocation.latitude,
                            longitude: driverLocation.driverLocation.longitude,
                        };
                    }
                    this.$data.hasStarted = route.status === 'In-Progress';
                    this.$data.showMap = this.$data.hasStarted;
                    if (this.$data.hasStarted && !this.intervalId) {
                        this.intervalId = window.setInterval(() => {
                            this.refreshRouteLocation();
                        }, 5000);
                    }
                } else {
                    this.$data.hasStarted = false;
                    if (this.intervalId) {
                        clearInterval(this.intervalId);
                        this.intervalId = null;
                    }
                }

            } else {
                this.isLinkValid = false;
            }
        } catch (error) {
            this.errorMessage = error as string;
            this.isLinkValid = false;
        }
    }

    private async refreshRouteLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/${this.$route.params.id}`,
        };
        const response = await iHttpService.get<DraftPrivatePayRequest>(apiRequest);
        if (response.success && response.data) {
            const route = response.data.transportRequest.routes[0];
            let googleMap = this.$refs.liveLocationMap as any;
            if (!googleMap) {
                googleMap = this.$refs.liveLocationMap as any;
            }
            if (route.tripDetails && route.tripDetails.driverLocation && googleMap) {
                googleMap.updateLocation(route.tripDetails.driverLocation);
                this.$data.driverLocation = route.tripDetails.driverLocation;
            }

            if (route.tripDetails && route.tripDetails.patientPickedUpAt && this.$data.mapRefreshCount === 0) {
                this.refreshMap();
                this.$data.mapRefreshCount++;
                this.$data.patientPickedUp = true;
            }
        }
    }

    private refreshMap() {
        this.$data.showMap = false;
        setTimeout(() => {
            this.$data.showMap = true;
        }, 500);
    }

    private isCurrentStep(stepKey: string): boolean {
        return stepKey === this.currentStepKey;
    }

    private isStepCompleted(stepKey: string): boolean {
        const currentIndex = this.steps.findIndex((s) => s.key === this.currentStepKey);
        const stepIndex = this.steps.findIndex((s) => s.key === stepKey);
        if (this.currentStepKey === 'PAYENT_COMPLETED') {
                return stepKey === 'PAYENT_COMPLETED' || stepKey === 'ASSIGNING_DRIVER' || stepIndex < currentIndex;
        }
        if (this.status === 'SERVICE_IN_PROGRESS') {
                return stepKey === 'SERVICE_IN_PROGRESS' || stepIndex < currentIndex;
        }
        if (this.currentStepKey === 'SERVICE_CANCELLED') {
            return stepIndex <= currentIndex;
        }

        if (this.currentStepKey === 'SERVICE_COMPLETED') {
            return stepIndex <= currentIndex;
        }
        return stepIndex < currentIndex;
    }

    private openFareDetails() {
        if (
            this.serviceRequest &&
            this.serviceRequest.invoice &&
            this.serviceRequest.invoice.details
        ) {
            this.fareDetails = this.serviceRequest.invoice.details;
        } else {
            this.fareDetails = null;
        }

        this.showFareDetails = true;
    }

    private close() {
        this.showFareDetails = false;
    }

    private goToPrivatePay() {
        const path = `${MedTransGoConstants.URL_PRIVATE_PAY}/${this.$route.params.id}`;
        this.$router.push(path);
    }

    private redirectToMTGWebsite() {
        location.href = 'http://www.accessbymedtransgo.com';
    }

    private async downloadReceipt() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUESTS_V2}/privatePay/${this.$route.params.id}/reciept`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<any>(apiRequest);
        if (response.success && response.data.url) {
            window.open(response.data.url);
        }
    }
}
